import Footer from "./Footer";
import Navigation from "./Navigation";
import WebGL3DBackground from "./WebGL3DBackground";
import { motion } from "framer-motion";

export default function TermsPage() {
  return (
    <div
      className="min-h-screen bg-[#040814] text-white"
      style={{ fontFamily: "'Roboto', sans-serif" }}
    >
      <Navigation />

      <section className="relative min-h-[90vh] flex items-center overflow-hidden py-24">
        {/* Background Elements */}
        <div className="absolute inset-0">
        </div>

        <div className="relative container mx-auto px-6">
          {/* Title */}
          <motion.div
            className="max-w-4xl mx-auto text-center mb-10"
            initial={{ opacity: 0, y: 35 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <motion.h1
              className="text-4xl md:text-5xl font-extrabold leading-tight text-white"
              initial={{ textShadow: "0px 0px 0px rgba(0,255,255,0)" }}
              animate={{ textShadow: "0px 0px 24px rgba(0,255,255,.35)" }}
              transition={{ duration: 1.4, repeat: Infinity, repeatType: "reverse" }}
            >
              Terms of Service
            </motion.h1>

            <p className="mt-4 text-base md:text-lg text-gray-300">
              PLEASE READ THESE TERMS OF SERVICE CAREFULLY BEFORE USING THE SERVICES OFFERED BY VARIABLE SOFT. BY VISITING THE WEBSITES OR USING THE SERVICES IN ANY MANNER, YOU AGREE THAT YOU HAVE READ AND AGREE TO BE BOUND BY AND A PARTY TO THE TERMS AND CONDITIONS OF THIS AGREEMENT TO THE EXCLUSION OF ALL OTHER TERMS.
            </p>
          </motion.div>

          {/* Card */}
          <motion.div
            className="max-w-5xl mx-auto"
            initial={{ opacity: 0, y: 50, scale: 0.97 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl p-6 md:p-10 transition-all duration-700 ease-out hover:shadow-blue-500/20 hover:border-white/20 hover:-translate-y-1">
              <div className="space-y-6 text-gray-200 text-sm md:text-base leading-relaxed">
                <motion.ul
                  className="list-decimal pl-5 space-y-4"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={{
                    hidden: {},
                    visible: { transition: { staggerChildren: 0.15 } },
                  }}
                >
                  {/* ITEM VARIANT */}
                  {[
                    <>
                      <strong>What are the basics of accessing the Service?</strong> The
                      Variable Soft website and any other linked pages, features, or
                      content offered from time to time by Company in connection
                      therewith (collectively, the “Website”) are owned and operated by
                      Company. The term “Services” includes, without limitation, use of
                      the Website and the Content (as defined below) offered by Company
                      on the Website. The Company’s product offerings are subject to
                      Company’s SaaS Customer Terms and Conditions located at
                      [www.variablesoft.com], as updated by Company from time to time,
                      or specific written terms agreed and signed by you and Company.
                      Company may change, suspend or discontinue the Services at any
                      time, including the availability of any feature, database, or
                      Content. Company may also impose limits on certain features and
                      services or restrict your access to parts or all of the Services
                      without notice or liability. Company reserves the right, in its
                      sole discretion, to modify this Agreement at any time by posting a
                      notice on the Website, or by sending you a notice. You shall be
                      responsible for reviewing and becoming familiar with any such
                      modifications. Your use of the Services following such
                      notification constitutes your acceptance of the terms and
                      conditions of this Agreement as modified.
                    </>,
                    <>
                      <strong>Who owns the Service and the Content?</strong> The
                      Website, the Services, and their contents may only be used in
                      accordance with the terms of this Agreement. All materials
                      displayed or performed on the Services (including, but not limited
                      to text, graphics, articles, photographs, images, illustrations
                      (also known as the “Content,” and which includes User Submissions
                      (as defined below))) are protected by copyright. You shall abide
                      by all copyright notices, trademark rules, information, and
                      restrictions contained in any Content accessed through the
                      Services, and shall not use, copy, reproduce, modify, translate,
                      publish, broadcast, transmit, distribute, perform, upload,
                      display, license, sell or otherwise exploit for any purposes
                      whatsoever any Content or third party submissions or other
                      proprietary rights not owned by you: (i) without the express prior
                      written consent of the respective owners, and (ii) in any way that
                      violates any third party right.
                    </>,
                    <>
                      How does Company treat your personal information? For information
                      regarding Company’s treatment of personally identifiable
                      information, please review Company’s current Privacy Policy at
                      [insert link], which is hereby incorporated by reference; your
                      acceptance of this Agreement constitutes your acceptance and
                      agreement to be bound by Company’s Privacy Policy.
                    </>,
                    <>
                      INDEMNITY. You will indemnify and hold Company, its parents,
                      subsidiaries, affiliates, officers, and employees harmless
                      (including, without limitation, from all damages, liabilities,
                      settlements, costs and attorneys’ fees) from any claim or demand
                      made by any third party due to or arising out of your access to
                      the Services, use of the Services, your violation of this
                      Agreement, or the infringement by you of any intellectual property
                      or other right of any person or entity.
                    </>
                  ].map((content, i) => (
                    <motion.li
                      key={i}
                      variants={{
                        hidden: { opacity: 0, y: 25 },
                        visible: { opacity: 1, y: 0 },
                      }}
                      transition={{ duration: 0.45, ease: "easeOut" }}
                      className="transition-all hover:translate-x-1"
                    >
                      {content}
                    </motion.li>
                  ))}
                </motion.ul>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
